@if ((kommissionierungBewegungen$ | async); as bewegungen) {
  <div class="flex flex-col-reverse full-width bg-surface lg:bg-transparent -mt-2 sticky -top-2 mb-3 !z-10 border-b border-gray-300 border-solid">
    <soft-step-header class="hidden" [steps]="steps" [currentIndex]="(warenzugangBuchenClicked$ | async) === false ? 6 : 7"
    [showLabels]="false" #stepper></soft-step-header>
    <soft-default-header
      class="px-4 pt-4 pb-3 bg-white"
      [overline]="stepper.stepText"
      [title]="$safeNavigationMigration(stepper.current()?.header)"
      [subtitle]="$safeNavigationMigration(stepper.current()?.subHeader)">
    </soft-default-header>
  </div>
  @if ((warenzugangBuchenClicked$ | async) === false) {
    <div class="flex flex-row w-full mb-1 mt-3 justify-between">
      <div class="font-bold text-sm text-primary-400">
        {{'#LLR_KOMMISSIONIERUNG.ARTIKELAUSWAHL.TITEL_ERFASSTE_ARTIKEL' | translate}}
      </div>
      @if (allePositionenAbgeschlossen) {
        <div
          class="font-bold text-sm text-red-800">
          {{'#LLR_KOMMISSIONIERUNG.WARENZUGANG_BUCHEN.TITEL_ALLE_ARTIKEL_ABGESCHLOSSEN' | translate}}
        </div>
      }
    </div>
    @if ((loading$ | async) === false) {
      <div class="flex flex-grow overflow-auto full-width w-full z-[0] lg:-mt-3 relative">
        <div class="flex flex-col w-full px-4 py-2 lg:py-4 mt-2">
          @for (bewegung of bewegungen; track bewegung) {
            <div class="soft-card rounded-sm flex flex-row w-full items-center justify-between mb-3 !p-3"
              [ngClass]="{'!bg-success-400': $safeNavigationMigration(bewegung?.kommissionierDaten?.abgeschlossen)}">
              <div class="flex flex-row w-full justify-between">
                <div class="flex flex-col w-4/5 gap-2">
                  <div class="flex flex-row w-full justify-between">
                    <div class="text-sm text-light">
                      {{bewegung?.bewebs?.artikel?.artikelnummer}}
                    </div>
                    @if (bewegung?.kommissionierDaten?.abgeschlossen) {
                      <div
                        class="text-sm text-light">
                        {{'#LLR_KOMMISSIONIERUNG.ARTIKELAUSWAHL.LABEL_ABGESCHLOSSEN' | translate}}
                      </div>
                    }
                  </div>
                  <div class="flex flex-row w-full">
                    <div class="font-semibold">
                      {{bewegung?.bewebs?.artikel?.artbez1}}
                    </div>
                  </div>
                  <div class="flex flex-row w-full">
                    <div class="text-sm text-light">
                      {{bewegung?.bewebs?.artikel?.artbez2}}
                    </div>
                  </div>
                </div>
                <div class="flex flex-row w-1/5 gap-4 self-center justify-end">
                  <div class="flex flex-col gap-2 justify-center items-end mr-4">
                    @if (!paletteEinzelEingabe) {
                      <div
                        class="font-semibold">
                        {{bewegung?.kommissionierDaten?.anz_paletten ?? 0}} Pal <!--{{bewegung?.kommissionierDaten?.arteh_palette?.arteh}}-->
                      </div>
                    }
                    <div class="font-semibold">
                      {{bewegung?.kommissionierDaten?.rest_menge}} {{bewegung?.kommissionierDaten?.arteh?.arteh}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="flex flex-col mt-5 pb-5 gap-3">
        <div class="flex soft-card rounded w-full h-24" *softRepeat="5">
          <div class="flex flex-col gap-2 items-start pb-1.5 pt-2">
            <div class="h-4 w-20 skeleton rounded"></div>
            <div class="h-4 w-24 skeleton rounded"></div>
            <div class="h-4 w-36 skeleton rounded"></div>
          </div>
        </div>
      </div>
    }
  }
  @if ((warenzugangBuchenClicked$ | async) === false) {
    <div
      class="flex flex-row gap-3 mt-auto mb-4">
      <button
        class="flex soft-button secondary rounded items-center justify-center h-16 w-full mt-2"
        (click)="warenzugangBuchenLaden('LF')">
        {{'#LLR_KOMMISSIONIERUNG.AKTIONEN.LABEL_WARENZUGANG_BUCHEN' | translate}}
        <br>
          {{'#LLR_KOMMISSIONIERUNG.AKTIONEN.LABEL_BESTELLUNGEN_OFFEN_LASSEN' | translate}}
        </button>
        <button
          class="flex soft-button primary rounded items-center justify-center h-16 w-full mt-2"
          (click)="warenzugangBuchenLaden('BS')">
          {{'#LLR_KOMMISSIONIERUNG.AKTIONEN.LABEL_WARENZUGANG_BUCHEN' | translate}}
          <br>
            {{'#LLR_KOMMISSIONIERUNG.AKTIONEN.LABEL_BESTELLUNGEN_ABSCHLIESSEN' | translate}}
          </button>
        </div>
      }
    }

    @if ((kommissionierung$ | async); as kommissionierung) {
      @if ((warenzugangBuchenClicked$ | async) === true) {
        <soft-warenzugang-buchen
          [kommissionierung]="kommissionierung"
          [eingabeLieferscheinnummerPflicht]="eingabeLieferscheinnummerPflicht"
          (warenzugangBuchenClicked)="warenzugangBuchen($event)">
        </soft-warenzugang-buchen>
      }
    }

